import React from 'react';
import styles from './styles.module.scss';
import {Button, Flex, Text} from '@priority-software/priority-style-react';
import texts from '../texts';
import {partsStore} from '../PartsStore';
import {observer} from 'mobx-react-lite';
import {useIsFetching} from 'react-query';
import {PageNav} from '@priority-software/priority-style-react/dist';
import {isRTL} from '../../../Localization';
import {PAGES_COUNT_QUERY} from '../consts';

interface Props {
    onConfirm: () => void;
    onClose: () => void;
}

const Footer = observer(({onConfirm, onClose}: Props) => {
    const {selectedItems, clearSelectedItem, setPage, page, pagesCount} = partsStore;
    const isFetching = useIsFetching({queryKey: [PAGES_COUNT_QUERY]});

    return (
        <Flex componentClasses={styles.footer}>
            <div className={styles.footerButtons}>
                <Text
                    wrap={false}
                    componentClasses={styles.footerSelected}
                    skin="label-2"
                    textColor="secondary-400"
                >
                    {texts.selected?.replace('X', selectedItems?.size)}
                </Text>
                {selectedItems?.size > 0 && (
                    <Button
                        onClick={clearSelectedItem}
                        componentClasses={styles.footerClear}
                        skin="text"
                        size="small"
                    >
                        {texts.clear}
                    </Button>
                )}
            </div>
            {isFetching === 0 && (
                <PageNav
                    componentClasses={styles.pageNav}
                    rtl={isRTL()}
                    onItemClick={setPage}
                    activePage={page}
                    pagesCount={Number(pagesCount || 0)}
                />
            )}
            <div className={styles.footerButtons}>
                <Button onClick={onClose} width="regularFixed" skin="secondary" size="large">
                    {texts.cancel}
                </Button>
                <Button
                    onClick={onConfirm}
                    disabled={!selectedItems?.size}
                    width="regularFixed"
                    size="large"
                >
                    {texts.confirm}
                </Button>
            </div>
        </Flex>
    );
});

export default Footer;
